import { of } from 'rxjs'
import {
  delayWhen,
  filter,
  ignoreElements,
  pairwise,
  tap
} from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import mixPanel from 'tracking/mixPanel'
import { getLocationChangeOperationCode } from 'domain/router'
import { getIsSaleFetched, getSaleProvider } from 'store/selectors'
import { awaitForSaleFetched } from '../../helpers/resources'
import { disableMixPanelTracking } from '../disable'

const hasOperationCodeChanged = ([prevLocationChange, locationChange]) =>
  getLocationChangeOperationCode(prevLocationChange) !== getLocationChangeOperationCode(locationChange)

const saleChange = (
  actions$,
  state$
) =>
  actions$.pipe(
    disableMixPanelTracking(actions$),
    ofType(LOCATION_CHANGE),
    delayWhen(() =>
      getIsSaleFetched(state$.value)
        ? of({})
        : awaitForSaleFetched(actions$, state$)
    ),
    pairwise(),
    filter(hasOperationCodeChanged),
    tap(() => {
      mixPanel.registerForAppSession({
        'Offer Provider': getSaleProvider(state$.value)
      })
    }),
    ignoreElements()
  )

export default saleChange
